
define('text!templates_dir/controls/validation-error.hbs',[],function () { return '<div class="validation-error {{cls}}" {{#if elId}}id="valerr-{{elId}}"{{/if}}>{{{errMessage}}}</div>\n';});

